/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// CompareImgs
import ReactCompareImage from 'react-compare-image';

// StagesCarouselCel
import StagesCarouselCel from '../index/NewsCel/StagesCarouselCel.js';

// core components

function News() {
  return (
    <>
      <div className="section section-dark section-nucleo-icons d-block d-sm-none d-none d-sm-block d-md-none">
        <h2 className="title gradient-title" style={{ textAlign: 'center' }}>News</h2>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-top-dark" style={{ textAlign: 'center' }} >
              <h3 className="title gradient-title">Remastered Sprites</h3>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Probably the biggest challenge for the game. Now each char sprite of the Season 2 Final has
                been remastered giving a much sharper appearance and making them be in context with the artistic aspect of the stages.
               </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <ReactCompareImage
                className="img-rounded img-responsive"
                leftImage={require("assets/img/Index/Rem_Char-16-9.png")}
                rightImage={require("assets/img/Index/Rem_Char-16-9-Pixel.png")}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h3 className="title gradient-title">Spectacular Stages</h3>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                One of the most important points to highlight in every MKDOTE release are the new stages that the game offers.
                Now, each stage was improved and optimized, giving a much sharper and more immersive quality.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <StagesCarouselCel className="img-rounded img-responsive" />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h3 className="title gradient-title">Cinematic camera system</h3>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Always keeping in motion and in context with what is happening on the screen, the camera now has a slight movement effect,
                with added zoom and less sensitivity to combos, bumps and drops.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <div className="embed-responsive embed-responsive-16by9">
                <video muted autoPlay={true} loop={1} title="intro" className="embed-responsive-item" src={require("assets/videos/camara.webm")} type="video/webm" ></video>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h3 className="title gradient-title">Beautiful User Interface</h3>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Menu, Select Screen, Fonts, Towers (Choose Your Destiny), Vs, Move List, Life Bars and any interface
                that the user needs to access are now in HD with a modern and clean style.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                alt="Select Screen"
                className="img-rounded img-responsive"
                src={require("assets/img/Index/Cel/UI_Select_Screen.jpg")}
              />
            </Col>
          </Row>
        </Container>
      </div>{" "}
    </>
  );
}

export default News;
